import { Grid, TextField, Typography } from "@mui/material";
import { CalculatorSelectFieldItemProps } from "../types/calculatorSelectFieldItemProps";

const CalculatorSelectFieldItem = ({
  text,
  value,
  onChange,
  children,
}: CalculatorSelectFieldItemProps) => (
  <Grid item container alignItems="center" spacing={2}>
    <Grid item xs={6}>
      <Typography>{text}</Typography>
    </Grid>
    <Grid item xs={6}>
      <TextField
        value={value}
        onChange={
          onChange as React.ChangeEventHandler<
            HTMLInputElement | HTMLTextAreaElement
          >
        }
        select
        fullWidth
      >
        {children}
      </TextField>
    </Grid>
  </Grid>
);

export default CalculatorSelectFieldItem;
